import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'osn-cxb-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {
  @Input() public title: string;
  @Input() public subtitle: string;
  @Input() public closeable = true;

  constructor(public dialogRef: MatDialogRef<DialogComponent>) {}

  public closeDialog(result?: any): void {
    this.dialogRef.close(result);
  }
}
